<template>
  <PageWrapper>
    <MasterAbsenceReports is-for-master></MasterAbsenceReports>
  </PageWrapper>
</template>

<script>
export default {
  data() {
    return {
      absenceReports: null,
      absenceReportsListFilters: {
        pageNumber: 1,
        count: 10,
        studentUserId: null,
        masterUserId: null,
      },
    };
  },
  methods: {
    async getAllAbsenceReportList() {},
  },
  components: {
    PageWrapper,
    SearchInput,
    CustomTable,
    MasterAbsenceReports,
  },
};
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import SearchInput from "@/views/components/Utils/SearchInput.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import MasterAbsenceReports from "@/views/components/Schedule/MasterAbsenceReports.vue";
</script>
